import styled from "styled-components";

export default styled.header`
text-transform: uppercase;
`;